import { render } from "./LimitedVer.vue?vue&type=template&id=a6693be0&scoped=true"
import script from "./LimitedVer.vue?vue&type=script&lang=js"
export * from "./LimitedVer.vue?vue&type=script&lang=js"

import "./LimitedVer.vue?vue&type=style&index=0&id=a6693be0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6693be0"]])

export default __exports__